import React from "react";
import BidForm from "../TradeCurrency/BidForm";
import { useEffect, useState, useContext } from "react";
import { LiaStarSolid, LiaTimesSolid } from "react-icons/lia";
function BiddingForm({ content }) {
  const {
    getDataById,
    handleOpenandCloseModal,
    setBidData,
    bidData,
    isSubmittingBid,
    handleSubmitBid,
  } = content;

  return (
    <div className="w-[25rem] fixed bg-p-wh shadow py-6 rounded top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
      <h2 className="text-[18px] font-semibold pb-2 mb-6 px-6 border-b-hf">
        Place a bid
      </h2>
      <span
        className="absolute items-center  top-6 right-6 text-2xl text-s-bk cursor-pointer hover:text-p-bk"
        onClick={() => handleOpenandCloseModal("close")}
      >
        <LiaTimesSolid />
      </span>
      <div className="px-6">
        <BidForm
          content={{
            offerDetails: getDataById,
            setBidData,
            bidData,
            isSubmittingBid,
            handleSubmitBid,
            handleOpenandCloseModal,
          }}
        />
      </div>
    </div>
  );
}

export default BiddingForm;
